import {Composition} from 'remotion';
import {ProMax} from './ProMax';
import {DURATION,FPS} from './content';

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition id="ProMaxVertical" component={ProMax} durationInFrames={DURATION} fps={FPS} width={1080} height={1920}/>
    </>
  );
};
